<template>
  <v-content>
        <div class="wedrive-bg-header-container"></div>
        <v-row v-if="isLoading" cols="12" justify="center">
            <v-col class="mx-auto" cols="12">
                <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%"/>
            </v-col>
        </v-row>

        <v-tabs v-if="!isLoading" v-model="selectedTab" 
          fixed-tabs 
          color="white"
          background-color="primary"
          class="wedrive-tabs-container fixNotchPaddingTop"
          @change="doCenterMap()"> 
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="0">{{ $t('detail.data') }}</v-tab>
            <v-tab key="1">{{ $t('detail.location') }}</v-tab> 
            <v-tab-item class="wedrive-tabs-item-container">
                <v-card class="mx-auto mb-4 card-wedrives-detail" min-width="300" style="padding-bottom: 45px;">
                    <v-card-text style="padding-bottom: 0;">
                        <v-row>
                            <v-col cols="12" style="padding-top: 0;">
                                <h3 style="color: #000;">{{ $t('detail.vehicle-info') }}</h3>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.alias') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? data.aliasMobile[0] : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.location') }}</span>
                                <span style="color: #717171; max-width: 70%; float: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    {{ data ? formatShortLocation(data.fractal[0]) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.postal-code') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? getFractalCodPostal(data.fractal[0]) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.speed') }}</span>
                                <span style="color: #717171; float: right;">{{ data && data.speed ? parseInt(data.speed) : '0' }} km/h</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.status') }}</span>
                                <v-img :src="data && data.stateDesc ? Object.entries(data.stateDesc[0]).length == 0 || 
                                    data.stateDesc[0].endsWith('OFF') ? 'img/OFF.png' : 'img/ON.png' : 'img/OFF.png'" width="20" style="float: right;"/>
                                <span style="margin-right: 10px; float: right;">{{ $t('detail.ignition')}} {{ data && data.stateDesc ? 
                                    Object.entries(data.stateDesc[0]).length == 0 || data.stateDesc[0].endsWith('OFF') ? 'OFF' : 'ON' : 'OFF' }}</span>
                            </v-col>
                                <v-col cols="12" style="padding-top: 20px;">
                                <h3 style="color: #000;">{{ $t('detail.last-comm') }}</h3>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.date') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? formatLocalDateTime(parseInt(data.timestamp)) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="padding-top: 20px;">
                                <h3 style="color: #000; display: inline;">{{ $t('detail.temperatures') }}</h3>
                                <v-btn class="primary" style="top: -7px; width: 130px; float: right;" @click="doTicket()">
                                    {{ $t('detail.ticket') }}
                                </v-btn>
                            </v-col>
                            <v-col cols="12" class="mx-auto" style="margin: 0; padding: 0; color: #989898; text-align: center;">
                                <v-icon color="#989898" style="top: -3px; margin-right: 5px;">mdi-update</v-icon>
                                <span>{{ $t('app.last-measurement') }}: {{ data ? formatLocalDateTime(parseInt(data.lastTemp)) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.sensor-1') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? formatTemperature(data.temp1) : '-' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.sensor-2') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? formatTemperature(data.temp2) : '-' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.sensor-3') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? formatTemperature(data.temp3) : '-' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.sensor-4') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? formatTemperature(data.temp4) : '-' }}</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item class="wedrive-tabs-item-container">
                <v-card class="mx-auto mb-4 card-wedrives-detail" min-width="300">
                    <v-card-text style="padding-bottom: 0;">
                        <v-row>
                            <v-col cols="12" style="padding-top: 0; border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.coords') }}</span>
                                <span style="color: #717171; float: right;">{{ data ? formatLatitudeLongitude(data.latitude, data.longitude) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.location') }}</span>
                                <span style="color: #717171; max-width: 70%; float: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    {{ data ? formatShortLocation(data.fractal[0]) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="border-bottom: 1px solid #cdcdcd;">
                                <span style="color: #000;">{{ $t('detail.street') }}</span>
                                <span style="color: #717171; float: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    {{ data ? getFractalStreet(data.fractal[0]) : '' }}</span>
                            </v-col>
                            <v-col cols="12" style="padding: 15px 12px 8px 12px;">
                                <iframe ref="iframe" id="map" src="maps.html" style="border: 0; width: 100%; height: 330px;"></iframe>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>

        <v-btn  dark fixed bottom right fab color="secondary" :loading="isLoading" @click="doRefresh()">
            <v-icon dark>mdi-autorenew</v-icon>
        </v-btn>

        <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                {{ alertText }}
                <v-btn text @click="showAlert=false">
									{{ $t('app.buttons.close') }}
                </v-btn>
        </v-snackbar>
        <!-- FIN BLOQUE ESTADO PETICIONES -->

    </v-content>
</template>


<script>

import BaseModule from "../../common/BaseModule"; 

export default {
    name: "DetailMain",
    mixins: [ BaseModule ],
    components: {},
    data() {
        return {
            idFleet: null,
            idMobile : null,
            isLoading: false,
            showAlert: false,
            alertColor: 'error',
            alertText: '',
            alertTimeout: 3000,
            selectedTab: 0,
            data: null,
            mapNeedsUpdate: false
        };
    },
    mounted: function() { 
        window.scrollTo(0, 0);

        window.$vue.$off('ne_backbutton');
        window.$vue.$on('ne_backbutton', this.processBackButton);
    },      
    computed: {
        mobileData() {
            return this.$store.state.wedrive.mobileData;
        },
    },
    methods: {
        processBackButton: function() {
            window.$vue.$off('ne_backbutton');
            this.$router.push({ name: 'home' });
        },
        doShowAlert: function(payload) {
            this.alertText = payload.text;
            this.alertColor = payload.color;
            this.alertTimeout = payload.timeout;
            this.showAlert = true;
        },
        doCenterMap: function() {
            if (this.selectedTab == 1 && this.mapNeedsUpdate) {
                var me = this;

                var timerId = setTimeout(() => {
                    me.$refs.iframe.contentWindow.centerMap(me.parseLatitudeLongitude(me.data.latitude), me.parseLatitudeLongitude(me.data.longitude));
                    me.mapNeedsUpdate = false;
                    clearTimeout(timerId);
                }, 400);
            }
        },
        doTicket: function() {
            if (!this.data) {
                return;
            }

            this.$router.push({ name: 'report', params: { idFleet: this.idFleet, idMobile: this.idMobile, aliasMobile: this.data.aliasMobile[0] } });
        },
        updateView: function() {
            if (!this.idMobile || !this.idFleet || !this.mobileData) {
                this.data = null;
                return;
            }

            for (var pos = 0; pos < this.mobileData.length; pos++) {
                var mobile = this.mobileData[pos];

                if (mobile.idMobile == this.idMobile && mobile.idFleet == this.idFleet) {
                    this.data = mobile;
                    this.mapNeedsUpdate = true;
                    this.doCenterMap();
                    this.$store.commit('wedrive/setMobileIndex', pos);
                    this.$store.commit('wedrive/setNavTitle', this.data.aliasMobile[0]);
                    return;
                }
            }

            this.data = null;
        },
        doRefresh: function() {
            this.isLoading = true;
            
            this.updateMobileData(
            () => {
                this.isLoading = false;
            }, 
            (error) => {
                this.isLoading = false;
                this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
            });
        }
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        mobileData: function (list) {
            this.updateView();
        },
        // eslint-disable-next-line no-unused-vars
        $route(to, from) {
            this.idFleet = to.params.idFleet;
            this.idMobile = to.params.idMobile;
            this.updateView();
        },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.idFleet = to.params.idFleet;
        vm.idMobile = to.params.idMobile;
        vm.$store.commit('wedrive/setMobileIndex', -1);
        vm.$store.commit('wedrive/setShowLastUpdate', true);
        vm.updateView();
      });
    }
};
</script>